import { requireField } from './validators';
import InventoryAssignment from './InventoryAssignment';

export default class InventoryItem {
  constructor(data = {}) {
    requireField(data.name, 'inventory.name');
    requireField(data.type, 'inventory.type');

    this.id = data.id || `inv-${Math.random().toString(36).slice(2, 9)}`;
    this.reference = data.reference || `INV-${Math.floor(Math.random() * 9000 + 1000)}`;
    this.name = data.name;
    this.type = data.type;
    this.serialNumber = data.serialNumber || '';
    this.imei = data.imei || '';
    this.description = data.description || '';
    this.condition = data.condition || 'Good';
    this.conditionNotes = data.conditionNotes || '';
    this.notes = data.notes || '';
    this.status = data.status || 'available';
    this.assignments = (data.assignments || []).map((a) => new InventoryAssignment(a));
    this.requests = data.requests || [];
    this.images = data.images || [];
    this.invoiceFile = data.invoiceFile || null;
    this.purchaseDate = data.purchaseDate || '';
    this.purchaseCost = data.purchaseCost || '';
    this.warrantyExpiry = data.warrantyExpiry || '';
    this.location = data.location || '';
    this.serviceContact = data.serviceContact || {
      name: '',
      phone: '',
      email: '',
      url: ''
    };
    this.safeguardingRelevant = Boolean(data.safeguardingRelevant);
    this.loanable = Boolean(data.loanable);
    this.addedBy = data.addedBy || data.createdBy || '';
    this.notesLog = data.notesLog || [];
    this.createdAt = data.createdAt || new Date().toISOString();
    this.updatedAt = data.updatedAt || new Date().toISOString();
  }

  get activeAssignment() {
    return this.assignments.find((assignment) => assignment.isActive) || null;
  }

  toJSON() {
    return {
      ...this,
      assignments: this.assignments.map((a) => a.toJSON())
    };
  }
}
